import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "./view.css";
import { get_market_analysis_list } from "../admin.api";
import Snackbar from "../../../components/snackbar/snackbar";
import Loader from "../../../components/loader/loader";
export default function View(props) {
  const [data, setData] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const selectedParam = useParams();
  const locationRow = props?.location?.state?.row;

  const getDetailsFromList = async () => {
    if (!selectedParam?.id) {
      return;
    }
    setIsActive(true);
    try {
      const res = await get_market_analysis_list();
      const list = Array.isArray(res) ? res : [];
      const row = list.find((x) => String(x?.id) === String(selectedParam.id));
      if (row) {
        setData(row);
      } else {
        setSnackMessage("Record not found");
        setIsSnackError(true);
        setSnackOpen(true);
      }
    } catch (error) {
      setSnackMessage(error?.response?.data?.message || error?.message || "Failed to fetch list");
      setIsSnackError(true);
      setSnackOpen(true);
    } finally {
      setIsActive(false);
    }
  };
  useEffect(() => {
    if (locationRow) {
      setData(locationRow);
      setIsActive(false);
      return;
    }
    getDetailsFromList();
  }, [selectedParam?.id]);
  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      props.history.push("/market-analysis");
    }
  };
  return (
    <div>
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      <Loader open={isActive} />
      <div className="view-container">
        <span className="d-flex justify-content-between">
          <h6 className="mb-0 pt-2">
            <b>Market Analysis Details</b>
          </h6>
        </span>
        <hr />
        <button
          type="button"
          className="btn btn-primary btn-sm  mb-3"
          onClick={(e) => {
            props.history.push("/market-analysis");
          }}
        >
          Back
        </button>
        <div className="data">
          <div className="row">
            <div className="col-3">Opportunity</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {data?.opportunity || "Not Available"}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
